var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#C7F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0547 25.9883C27.3808 25.9883 28.6525 25.4615 29.5902 24.5238C30.5279 23.5861 31.0547 22.3144 31.0547 20.9883C31.0547 19.6622 30.5279 18.3904 29.5902 17.4527C28.6525 16.5151 27.3808 15.9883 26.0547 15.9883C24.7286 15.9883 23.4568 16.5151 22.5192 17.4527C21.5815 18.3904 21.0547 19.6622 21.0547 20.9883C21.0547 22.3144 21.5815 23.5861 22.5192 24.5238C23.4568 25.4615 24.7286 25.9883 26.0547 25.9883ZM26.0547 25.9883C28.0677 25.9883 29.8267 26.7483 31.0777 28.0113C31.8194 28.7633 32.3743 29.6788 32.6977 30.6843M26.0547 25.9883C22.0547 25.9883 19.0547 28.9883 19.0547 32.9883V37.9883H29.0547M30.0547 33.8123L34.2447 36.9883L41.0547 27.9883",
    stroke: "#002C54",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.570123fb791d6ed16fe26a8e8ca9fd66.svg";
export { ForwardRef as ReactComponent };